export const lenisStore = { current: null };

export function scrollToSection(id) {
  const el = document.getElementById(id);
  if (!el) return;
  const y = el.getBoundingClientRect().top + window.scrollY - 72;
  if (lenisStore.current) {
    lenisStore.current.scrollTo(y, { duration: 1.2 });
  } else {
    window.scrollTo({ top: y, behavior: "smooth" });
  }
}
